import { QuestionPassStateId } from '../../../learnware/LearnwareEnums';
import { QuestionPassState } from '../QuestionPassState';
export class QuestionPassState_Phase1 extends QuestionPassState {
    id = QuestionPassStateId.Phase1;
    name = 'Vokabeln in Phase 1';
    color = 'primary';
    orderInProgressbar = 7;
}
